/* V2.9.2: progressive contents links only. No page routing, rewrites, fetches or cart interception. */
(function () {
  'use strict';
  function enhance(scope) {
    (scope || document).querySelectorAll('[data-cp292-source]').forEach(function (root) {
      var body = root.querySelector('[data-cp292-body]');
      if (body && !body.dataset.cpChapters) {
        var parents = Array.from(new Set(Array.from(body.querySelectorAll('h2')).map(function (h) { return h.parentElement; })));
        parents.forEach(function (parent) {
          if (parent.classList.contains('cp292-chapter')) return;
          var nodes = Array.from(parent.childNodes), chapter = null;
          nodes.forEach(function (node) {
          if (node.nodeType === 1 && node.tagName === 'H2') {
            chapter = document.createElement('section'); chapter.className = 'cp292-chapter';
            parent.insertBefore(chapter, node);
          }
          if (chapter) chapter.appendChild(node);
          });
        });
        body.dataset.cpChapters = 'true';
      }
      var toc = root.querySelector('[data-cp292-toc]');
      var nav = root.querySelector('[data-cp292-toc-links]');
      if (!body || !toc || !nav || nav.childElementCount) return;
      var headings = Array.from(body.querySelectorAll('h2')).filter(function (h) {
        return h.textContent.trim().length > 0 && h.textContent.trim().length < 140;
      }).slice(0, 12);
      if (headings.length < 2) return;
      headings.forEach(function (heading, i) {
        if (!heading.id) {
          var base = 'cp-detail-' + (i + 1), id = base, suffix = 1;
          while (document.getElementById(id)) id = base + '-' + suffix++;
          heading.id = id;
        }
        var a = document.createElement('a');
        a.href = '#' + encodeURIComponent(heading.id);
        a.textContent = heading.textContent.trim();
        nav.appendChild(a);
      });
      toc.hidden = false;
      var disclosure = toc.querySelector('[data-cp292-toc-disclosure]');
      if (disclosure && window.matchMedia('(max-width: 989px)').matches) disclosure.open = false;
      nav.addEventListener('click', function (event) {
        var link = event.target.closest('a');
        if (!link) return;
        var target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
        if (!target) return;
        // Keep the full saved copy intact; open enclosing disclosures for direct links.
        var parent = target.parentElement;
        while (parent) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; }
        if (disclosure && window.matchMedia('(max-width: 989px)').matches) disclosure.open = false;
        target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
        nav.querySelectorAll('a').forEach(function (a) { a.removeAttribute('aria-current'); });
        link.setAttribute('aria-current', 'location');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { enhance(document); });
  else enhance(document);
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target); });
})();
